export const worldIt = {
  'world.seo.title': 'Il Mondo',
  'world.seo.description':
    'Esplora le mappe interattive di Grymwyrd — i suoi regni, le rovine e i luoghi leggendari, in cartografia 2D e in un globo 3D rotabile.',
  'world.heading': 'Il Mondo',
  'world.intro':
    'Traccia il crepuscolo eterno. L\'atlante è costruito per la visione stratificata — ingrandisci dal mondo intero fino a un singolo dungeon. Solo il livello più alto è interattivo per ora; i livelli più profondi si apriranno via via che i regni verranno mappati.',

  'world.viewMode.label': 'Modalità di visualizzazione della mappa',
  'world.viewMode.map2d': 'Mappa 2D',
  'world.viewMode.globe3d': 'Globo 3D',

  'world.gazetteer.navLabel': 'Luoghi e scene',
  'world.gazetteer.heading': 'Prontuario',
  'world.gazetteer.sampleNotice':
    'Mostrando luoghi campione — il vero rilievo del cartografo non è ancora registrato.',
  'world.gazetteer.error': 'L\'archivio dell\'atlante non può essere raggiunto.',

  'world.loading.atlas': 'Srotolando l\'atlante…',
  'world.loading.globe': 'Girando il mondo…',

  'world.layersActive': '{active} di {total} livelli attivi.',
  'world.globeHint':
    'Trascina per ruotare (la rotazione automatica si pausa mentre esplori, riprendendosi dopo un minuto di inattività); scorri per ingrandire. Passa il cursore su un esagono per rivelare la sua campagna, fai clic per entrare.',
  'world.webglUnavailable':
    'Il globo 3D richiede WebGL, che non è disponibile qui — mostrando l\'atlante 2D.',

  'world.campaign.capitalRegion': 'Regione Capitale',
  'world.campaign.territory': 'Territorio di Campagna',
  'world.campaign.enter': 'Entra in Campagna',
  'world.campaign.stay': 'Resta in Orbita',

  'world.layers.heading': 'Livelli Mappa',
  'world.layers.gmBadge': 'DG',
  'world.layers.gmRequired': 'Richiede il ruolo di Dungeon Master.',

  'world.marker.sampleBadge': 'Dati campione',
  'world.marker.viewInEncyclopedia': 'Visualizza nell\'Enciclopedia',
  'world.marker.placeholderNote':
    'Questo è un sito segnaposto — una volta scritta la sua tradizione leggendaria si collegherà all\'Enciclopedia.',

  'world.map2d.ariaLabel': 'Mappa interattiva del mondo',
  'world.map2d.noOverworld': 'La cartografia del mondo non è ancora inscritta — mostrando il vuoto',

  'world.globe.hint.enter': 'Entra ▸',
  'world.globe.hint.open': 'Apri ▸',
  'world.globe.hint.claim': 'Rivendica ▸',
  'world.globe.uncharted': 'Terre Inesplorate',
  'world.globe.unchartedBlurb':
    'Nessuna campagna ha reclamato questo esagono del crepuscolo eterno. Pianta il primo stendardo.',
  'world.globe.capitalLabel': 'Grymwyrd',
} as const
